import { u as useEventTarget } from "./helpers.js";
function readonlyFederationRef(ref) {
  return { get: ref.get, subscribe: ref.subscribe };
}
function createFederationRef(defaultValue) {
  const { subscribe, publish } = useEventTarget();
  let valueInternal = defaultValue;
  return {
    get() {
      return valueInternal;
    },
    set(value) {
      if (!Object.is(value, valueInternal)) {
        const oldValue = valueInternal;
        valueInternal = value;
        publish("change", value, oldValue);
      }
    },
    subscribe(fn) {
      return subscribe("change", fn);
    }
  };
}
function createFederationStorage(initialStorage) {
  const { subscribe, publish } = useEventTarget();
  let storage = initialStorage ?? {};
  return {
    has,
    set,
    setAll,
    get,
    remove,
    getAll,
    on
  };
  function has(key) {
    return key in storage;
  }
  function set(key, value) {
    setStorage({ ...storage, [key]: value });
  }
  function setAll(data) {
    setStorage(data);
  }
  function get(key) {
    return storage[key];
  }
  function remove(key) {
    const newStorage = { ...storage };
    delete newStorage[key];
    setStorage(newStorage);
  }
  function getAll() {
    return storage;
  }
  function on(event, fn) {
    return subscribe(event, fn);
  }
  function setStorage(data) {
    const oldStorage = storage;
    storage = data;
    publish("change", storage, oldStorage);
  }
}
export {
  createFederationRef as a,
  createFederationStorage as c,
  readonlyFederationRef as r
};
//# sourceMappingURL=storage.js.map
